import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetProspectorSavedFilters as GetSavedFiltersQuery} from 'nutshell-graphql-types';

import GET_PROSPECTOR_SAVED_FILTERS from '../queries/get-prospector-saved-filters.graphql';

export const PROSPECTOR_TYPE = 21;

export const useGetProspectorSavedFilters = () => {
    const {data, error, loading, refetch} = useQuery<GetSavedFiltersQuery, Record<any, any>>(
        GET_PROSPECTOR_SAVED_FILTERS,
        {
            variables: {
                includeShared: true,
                includeDefault: false,
                type: PROSPECTOR_TYPE,
            },
            fetchPolicy: 'cache-and-network',
        }
    );

    const prospectorSavedFilters = data ? data.prospectorSavedFilters : null;

    return {
        savedFilters: prospectorSavedFilters || [],
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
        refetch,
    };
};
